import { GetScreenRect } from "vwebapp-framework";
import { Timer, VRect, Vector2i } from "js-vextensions";
import { UIFocusEngine_OverlayUI } from "./UIFocusEngine_OverlayUI";
export class OverlayControlInfo {
}
let lastVoiceKeyNumber = 1400;
function ResetAutoVoiceKeyProvider() {
    lastVoiceKeyNumber = 1400;
}
function GetAutoVoiceKey() {
    let voiceKeyNumber = lastVoiceKeyNumber + 1;
    // don't accept multiples of 10, else, eg. "..49" might be recognized as "..40" prior to "..49"
    if (voiceKeyNumber.toString().endsWith("0")) {
        voiceKeyNumber++;
    }
    lastVoiceKeyNumber = voiceKeyNumber;
    return voiceKeyNumber.toString();
}
export class UIFocusEngine {
    constructor(voiceEngine) {
        this.updateTimer = new Timer(1000, () => {
            const viewportRect = new VRect(0, 0, window.innerWidth, window.innerHeight);
            // add .focusTarget to other elements wanted supported
            const uiEls = Array.from(document.querySelectorAll(".focusTarget, .Button:not(.notFocusTarget), a:not(.notFocusTarget), input:not(.notFocusTarget), select:not(.notFocusTarget), textarea:not(.notFocusTarget)"));
            const uiElsInViewport = uiEls.filter(el => GetScreenRect(el).Intersects(viewportRect));
            ResetAutoVoiceKeyProvider();
            this.controlInfos = uiElsInViewport.map((el, index) => {
                const rect = GetScreenRect(el);
                const labelPos = new Vector2i(rect.Right, rect.Top);
                const voiceKey = GetAutoVoiceKey();
                //const labelText = `14${index.toString().padStart(2, "0")}`;
                //const labelText = (index + 1).toString().padStart(2, "0");
                return { index, element: el, rect, labelPos, voiceKey, labelText: voiceKey.slice(2) };
            });
            if (UIFocusEngine_OverlayUI.main) {
                UIFocusEngine_OverlayUI.main.RefreshFor(this);
            }
        });
        this.controlInfos = [];
        this.voiceEngine = voiceEngine;
    }
    //@O enabled = false;
    Start() {
        this.updateTimer.Start();
    }
    Stop() {
        this.updateTimer.Stop();
        if (UIFocusEngine_OverlayUI.main) {
            UIFocusEngine_OverlayUI.main.RefreshFor(this);
        }
    }
}
